import React from "react";
import './spinload.css'
import './blobs.css'
import './whirlpool.css'
import './twelve.css'

export function renderLoader() {
  const which = Math.floor(Math.random() * 4);
  switch (which) {
    default:
    case 0:
      return OgSpin()
    case 1:
      return BlobSpin()
    case 2:
      return Whirlpool()
    case 3:
      return twelve()
   }
}
function OgSpin() {
  return (
    <div className="loader" />
  )
}

function BlobSpin() {
  return(
    <div className="blob-spinner">
    <div className="blob top"></div>
    <div className="blob bottom"></div>
    <div className="blob left"></div>
      <div className="blob move-blob"></div>
    </div>
  )
}

function Whirlpool() {
  return (
    <div className="whirlpool">
    <div className="ring ring1"></div>
    <div className="ring ring2"></div>
    <div className="ring ring3"></div>
    <div className="ring ring4"></div>
    <div className="ring ring5"></div>
    <div className="ring ring6"></div>
    <div className="ring ring7"></div>
    <div className="ring ring8"></div>
    <div className="ring ring9"></div>
    </div>
  )
}
function twelve() {
  return(
    <div className="loader12">
      <div className="inner one"></div>
      <div className="inner two"></div>
      <div className="inner three"></div>
    </div>
  )
}